import angular from 'angular';
import uiRouter from 'angular-ui-router';
import usersComponent from './users.component';

let usersModule = angular.module('app.containers.users', [
  uiRouter,
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('users', {
      url: '/users',
      template: '<users></users>'
    })
    // .state('users', {
    //   url: '/users',
    //   template: '<users></users>'
    // })
})

.component('users', usersComponent);

export default usersModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/users/users.js
 **/